<h1 mat-dialog-title>Are You Sure ?
  <button id="module_profile_module_customerdialog_1"  mat-icon-button color="primary" class="subcSend" type="button" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<div class="mat-dialog-content">
  Updating your profile will require you to go through the Verification process again.
</div>
<div mat-dialog-actions class="mat-dialog-actions">
  <button id="module_profile_module_customerdialog_2" mat-button mat-dialog-close class="btnCustom btn-outline" (click)="closeDialog(false)">Cancel</button>
  <button id="module_profile_module_customerdialog_3" mat-button mat-dialog-close class="btnCustom btn-primary" (click)="closeDialog(true)">Update Profile</button>
</div>